import { lazy, Suspense } from "react";
import LoadingFeedback from "@/components/shared/loading/LoadingFeedback";

const Branches = lazy(() => import("../pages/Branches"));
const BranchDetails = lazy(() => import("../pages/BranchDetails"));

export const branchesRoutes = [
  {
    path: "/branches",
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<LoadingFeedback />}>
            <Branches />
          </Suspense>
        ),
      },
      {
        path: ":id",
        element: (
          <Suspense fallback={<LoadingFeedback />}>
            <BranchDetails />
          </Suspense>
        ),
      },
    ],
  },
];
